<template>
  <div class="user">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <participant-search-bar @selectedGroupObj="setAndLoadGroupObj" @searchString="setFiteredParticipantList" v-bind:disableBarAndFilter="disableFilterAndSearch" @resetFilter="resetFilter" v-bind:resetEnteredSearchField="getResetEnteredSearchFieldFlag" @updateResetEnteredSearchField="changeEnteredSearchFieldFlag" v-bind:resetSearchBarFilterValues="resetSearchBarFilterValues"></participant-search-bar>
      <participant-menu @showParticipantList="updateShowParticipantListFlag"></participant-menu>
      <participant-list 
      v-bind:participantList="ParticipantListValue"
      v-bind:usersPerPage="usersPerPage"
      v-bind:totalParticipantCount="totalParticipantCount"
      v-bind:resetPagination="resetPagination"
      v-if="showParticipantList"
      @changePage="onPageClick"
      @updatePaginationFlag="resetPaginationFlag"
      @sortBasedOnColumnName="sortRecordBasedOnColumn"
      @refreshList="refreshParticipantList"></participant-list>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>         
  </div>  
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import ParticipantSearchBar from '@/components/ParticipantSearchBar'
import ParticipantMenu from '@/components/ParticipantMenu'
import ParticipantList from '@/components/ParticipantList'
import { participantService } from '@/server-util/participant-service'
import CopyrightElement from '@/components/CopyrightElement' // copyright Menu
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import ErrorPage from '@/pages/Error'
import Loader from '@/components/dashboard/Loader'
export default {
  created: function () {
    this.getAllParticipantList(1)
    this.trackPageLoad()
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      showParticipantList: false,
      currentSelectedGroupObj: null,
      enrolledParticipantList: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      disableFilterAndSearch: false,
      resetEnteredSearchField: false,
      isOptionClicked: false,
      isUserFilteringResults: false,
      resetPagination: false,
      sortOrder: 'asc',
      sortBy: 'Username',
      totalParticipantCount: 0,
      usersPerPage: constants.userPerPage,
      searchString: '',
      resetSearchBarFilterValues: false,
      currPageIndex: 1
    }
  },
  components: {
    'participant-search-bar': ParticipantSearchBar,
    'participant-menu': ParticipantMenu,
    'participant-list': ParticipantList,
    'alert-box': AlertBox,
    'Copyright-Element': CopyrightElement,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    onPageClick (pageNum) {
      /*
      if (this.currentSelectedGroupObj !== null) {
        this.getEnrolledParticipants(pageNum)
      } else {
        this.getAllParticipantList(pageNum)
      }
      */
      this.getAllParticipantList(pageNum)
    },
    resetPaginationFlag (value) {
      this.resetPagination = value
    },
    sortRecordBasedOnColumn (value) {
      this.sortOrder = value.SortType
      this.sortBy = value.ColumnName
      console.log('this.sortOrder: ' + this.sortOrder + ' this.sortBy: ' + this.sortBy)
      this.resetPagination = true
      this.getAllParticipantList(1)
    },
    changeEnteredSearchFieldFlag (value) {
      // AK: After successfully resetting search field, change flag to false again
      this.resetEnteredSearchField = value
      // AK: As filter is reset means user not filtering hence change flag to flase
      this.isUserFilteringResults = false
      // this.resetPagination = true
      // this.getAllParticipantList(1)
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Participant Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Manage_MyProfile,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'PARTICIPANT',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    },
    resetFilter (value) {
      // AK: Show Original list to user
      // this.enrolledParticipantList = this.$store.state.userList
      this.resetPagination = true
      this.currentSelectedGroupObj = null
      this.getAllParticipantList(1)
      // AK: Case is when user select such group which does not contain any participants
      this.showParticipantList = true
      // AK: As filter is reset means user not filtering hence change flag to flase
      this.isUserFilteringResults = false
    },
    refreshParticipantList () {
      // AK: Reset input search field
      // this.resetEnteredSearchField = true
      // AK: As Participant list is refreshed means we clear the filter hence change flag to false again
      this.isUserFilteringResults = false
      // AK: After updating user details refresh list again
      /*
      if (this.currentSelectedGroupObj !== null) {
        // AK: If group object found i.e. filter applied then get Enrolled Participants
        this.getEnrolledParticipants(1)
      } else {
        // AK: If group object not found then get All participants
        this.resetPagination = true
        this.getAllParticipantList(1)
      }
      */
      // this.searchString = ''
      // this.currentSelectedGroupObj = null
      console.log('********')
      // this.resetPagination = true
      this.getAllParticipantList(this.currPageIndex)
    },
    updateShowParticipantListFlag (newValue) {
      // AK: If showParticipantListFlag is set to false means user clicked on option
      this.isOptionClicked = !newValue
      // AK: If user does not apply filter and pressed < Participant list option then do not show list
      if ((this.enrolledParticipantList !== undefined && this.enrolledParticipantList !== null)) {
        if (this.enrolledParticipantList.length !== 0) {
          this.showParticipantList = newValue
        }
      }
      // AK: If showParticipantList flag is set to true then only enable search and filter else disable it
      if (newValue === true) {
        this.searchString = ''
        this.currentSelectedGroupObj = null
        this.disableFilterAndSearch = false
        // AK: Refresh participant list Each time when user pressed '< Back to list' option
        this.refreshParticipantList()
      } else {
        this.disableFilterAndSearch = true
        // AK: Reset the filter values after user left the participant listing screen
        this.resetParticipantFilterBarValues()
      }
    },
    resetParticipantFilterBarValues: function () {
      this.resetSearchBarFilterValues = true
      var _this = this
      setTimeout(function () {
        _this.resetSearchBarFilterValues = false
      }, 100)
    },
    setAndLoadGroupObj (newValue) {
      // AK: as soon as user selected any group then get enrolled Participants
      this.currentSelectedGroupObj = newValue
      // this.getEnrolledParticipants(1)
      this.getAllParticipantList(1)
    },
    getEnrolledParticipants: function (pageNum = 1) {
      var storeObj = this.$store
      var _this = this
      console.log('getEnrolledParticipants: ' + pageNum)
      if (
        this.currentSelectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        participantService
          .getParticipantListUsingGroupId(
            storeObj.state.access_token,
            this.currentSelectedGroupObj.GroupId,
            pageNum,
            this.usersPerPage,
            this.searchString
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCourseList
                this.enrolledParticipantList = responseObj.data.Users
                this.totalParticipantCount = responseObj.data.TotalUsers
                this.resetPagination = true
                // AK: Store it into state for search participant result
                storeObj.state.participantListForCurrentSelectedGroup = responseObj.data
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                if (responseObj.data.length === 0) {
                  // AK: Hide participant list if already visible to user and user re-choosed something else
                  _this.showParticipantList = false
                  _this.showAlertDialog = true
                  _this.errorMsg = 'No participant found for select \'' + this.currentSelectedGroupObj.GroupName + '\' group.'
                } else {
                  // AK: Initially / very first time if user select any group then to show list set flag to true
                  _this.showParticipantList = true
                }
                // console.log(JSON.stringify(this.enrolledParticipantList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'GroupId is NULL hence declined LOADING ENROLLED Participant LIST OPERATION'
        )
      }
    },
    setFiteredParticipantList (newValue) {
      console.log('setFiteredParticipantList: ' + newValue)
      this.searchString = newValue
      this.resetPagination = true
      this.getAllParticipantList(1)
      // this.enrolledParticipantList = newValue
      // AK: set isUserFilteringResults to true to avoid refreshing participant list during search
      this.isUserFilteringResults = true
    },
    getAllParticipantList: function (pageNum) {
      var storeObj = this.$store
      var _this = this
      console.log('getAllParticipantList: ' + pageNum)
      this.currPageIndex = pageNum
      var groupId = null
      if (this.currentSelectedGroupObj !== null && this.currentSelectedGroupObj !== undefined && this.currentSelectedGroupObj !== '') {
        groupId = this.currentSelectedGroupObj.GroupId
      }
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null
      ) {
        _this.$store.state.isLoading = true
        // _this.showParticipantList = false
        participantService
          .getAllParticipantListForPagination(
            storeObj.state.access_token,
            pageNum,
            this.usersPerPage,
            this.searchString,
            groupId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it
                storeObj.state.totalUsers = responseObj.data.TotalUsers
                storeObj.state.userList = responseObj.data.Users
                this.totalParticipantCount = responseObj.data.TotalUsers
                // AK: If user is not filtering results then only assign it (To avoid lose of filtered result records)
                /*
                if (!this.isUserFilteringResults) {
                  // console.log('User not filtering results hence stored list locally as well as stored in global variable')
                  // AK: Assign to local varible
                  _this.enrolledParticipantList = responseObj.data.Users
                } else {
                  console.log('User filtering results hence not stored list locally but store in global variable')
                } */
                _this.enrolledParticipantList = responseObj.data.Users
                // AK: Hide spinner if its showing
                if (_this.$store.state.isLoading === true) {
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                }
                if (responseObj.data.length === 0) {
                  // AK: Hide participant list if already visible to user and user re-choosed something else
                  _this.showParticipantList = false
                  _this.showAlertDialog = true
                  _this.errorMsg = 'No participant(s) found.'
                } else {
                  // AK: Initially / very first time if user select any group then to show list set flag to true
                  if (!this.isOptionClicked) {
                    // AK: If not clicked any option then only show list
                    _this.showParticipantList = true
                  }
                }
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // AK: Hide spinner if its showing
                if (_this.$store.state.isLoading === true) {
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                }
              }
            },
            errorObj => {
              // AK: Hide spinner if its showing
              if (_this.$store.state.isLoading === true) {
                // this.showSpinner = false
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                _this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                _this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined LOADING ALL Participant LIST OPERATION'
        )
      }
    }
  },
  computed: {
    ParticipantListValue: {
      get: function () {
        return this.enrolledParticipantList
      }
    },
    getResetEnteredSearchFieldFlag: {
      get: function () {
        return this.resetEnteredSearchField
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'users'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.user {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-bottom-3Perc
{
	margin-bottom: 3%;
}
.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.footer{
    /* position: fixed; */
    left: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/User.vue